import { AllocationElementDiagramAnchor } from 'src/models/anchor-and-version/allocation-element-diagram.model';
import { AllocationElementDiagramService } from 'src/services/anchor-and-version-services/allocation-element-diagram.service';
import { CrudAllocationElementDiagramModalComponent } from '../../crud/crud-modals/crud-allocation-element-diagram-modal.component';
import { deepCopy } from 'src/utils/other.util';

export interface OpenDuplicateDiagramModalOptions {
    modal: CrudAllocationElementDiagramModalComponent;
    sourceAed: AllocationElementDiagramAnchor;
    allocationElementDiagramService: AllocationElementDiagramService;
    onSave: (duplicatedAed: AllocationElementDiagramAnchor) => Promise<void>;
    onCancel?: () => void;
}

export async function openDuplicateDiagramModal({
    modal,
    sourceAed,
    allocationElementDiagramService,
    onSave,
    onCancel,
}: OpenDuplicateDiagramModalOptions): Promise<void> {
    if (!sourceAed.validVersion) {
        throw new Error('Diagram cannot be duplicated because it has no valid version.');
    }

    const sourceVersion = deepCopy(sourceAed.validVersion);
    sourceVersion.name = `Copy of ${sourceVersion.name}`;

    modal.modalProps.anchor = undefined;
    modal.modalProps.version = sourceVersion;
    modal.modalProps.service = allocationElementDiagramService;
    modal.modalProps.onClose = onCancel;
    const userFunctionField = modal.modalProps.anchorFields.find(
        (field) => field.field === 'userFunctionAnchorKey'
    );
    const previousUserFunctionDefault = userFunctionField?.defaultValue;
    const previousSkipPendingChangesCountRefresh = modal.modalProps.skipPendingChangesCountRefresh;
    const restoreModalDefaults = () => {
        if (userFunctionField) userFunctionField.defaultValue = previousUserFunctionDefault;
        modal.modalProps.skipPendingChangesCountRefresh = previousSkipPendingChangesCountRefresh;
    };

    if (userFunctionField) userFunctionField.defaultValue = sourceAed.userFunctionAnchorKey;
    modal.modalProps.skipPendingChangesCountRefresh = true;
    modal.modalProps.onClose = () => {
        restoreModalDefaults();
        onCancel?.();
    };
    modal.modalProps.onSave = async (createdItem) => {
        try {
            await onSave(createdItem as AllocationElementDiagramAnchor);
        } finally {
            restoreModalDefaults();
        }
    };

    await modal.onOpen();
}
